import styled from "styled-components";

export const SettingsWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
